// Sidebar entries owned by the Marketing module. The shell places them: see
// src/app/nav.tsx and src/modules/README.md.
import { SidebarType } from '@/types/shared'
import { resources, scopes } from '@/utils/permission'
import { marketingPaths } from './paths'

export const marketingNav = {
    contacts: {
        title: 'marketing:sidebar_title',
        path: marketingPaths.customerMkt,
        rsname: resources.contact,
        require_scopes: [scopes.index],
        visible_permission_denied: false,
    },
} satisfies Record<string, SidebarType>
